import axios, { AxiosResponse } from "axios";

import Stripe from "stripe";
import { ENV } from "../constants/environment.base";
import { IUser } from "../types/types";

export class UserService {
  private readonly API_ROUTE_PREFIX: string = "user";
  private readonly API_PREFIX: string =
    this.API_ROUTE_PREFIX !== ""
      ? `${ENV.API_ENDPOINT}/${this.API_ROUTE_PREFIX}`
      : ENV.API_ENDPOINT;

  /**
   * Get user
   *
   * @returns Promise with user response
   */
  public logged: () => Promise<AxiosResponse<IUser>> = () => {
    return axios.get(`${this.API_PREFIX}/`);
  };

  /**
   * Delete user
   *
   * @returns Promise with user deletion response
   */
  public delete: () => Promise<
    AxiosResponse<{
      message: string;
      userDeleted: { id: string };
    }>
  > = () => {
    return axios.delete(`${this.API_PREFIX}/`);
  };

  /**
   * Create setup intent
   */
  public create_setup_intent: () => Promise<
    AxiosResponse<{ client_secret: string }>
  > = () => {
    return axios.post(`${this.API_PREFIX}/create-setup-intent`);
  };

  /**
   * List payment methods
   */
  public payment_methods: () => Promise<
    AxiosResponse<{ payment_methods: Stripe.PaymentMethod[] }>
  > = () => {
    return axios.get(`${this.API_PREFIX}/payment-methods`);
  };

  /**
   * Remove payment method
   */
  public remove_payment_method: (payment_method_id: string) => Promise<
    AxiosResponse<{
      message: string;
      ok: boolean;
    }>
  > = (payment_method_id) => {
    return axios.delete(`${this.API_PREFIX}/remove-payment-method`, {
      data: { payment_method_id },
    });
  };
}
